import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50855df4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper_start-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "В мире книг", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("article", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Инструкция:"),
  /*#__PURE__*/_createElementVNode("p", null, " Распредели книги, ориентируясь на названия, по соответствующим рубрикам таблицы: «Жанры фольклора», «Не являются жанрами фольклора». ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_green_button = _resolveComponent("green-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in",
      appear: ""
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _hoisted_3,
    _createVNode(_component_green_button, {
      text: 'Продолжить',
      url: 'books'
    })
  ]))
}